import {
  makeStyles,
  tokens,
  type GriffelStyle,
} from "@fluentui/react-components";

const headerRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "12px",
  marginBottom: "12px",
  borderBottom: "1px solid #e3e8ee",
  paddingBottom: "10px",
  flexWrap: "wrap",
} satisfies GriffelStyle;

const grid = {
  display: "grid",
  alignItems: "center",
  fontSize: "14px",
  lineHeight: 1.5,
  color: tokens.colorNeutralForeground1,
} satisfies GriffelStyle;

export const sharedStyles = {
  page: {
    paddingTop: "5px",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "8px",
  },
  section: {
    backgroundColor: tokens.colorNeutralBackground2,
    border: "1px solid #d9dfe6",
    borderRadius: "10px",
    padding: "18px 22px 12px",
    boxSizing: "border-box",
    "@media (max-width: 768px)": {
      padding: "14px 14px 8px",
    },
  },
  sidePanelSection: {
    padding: "24px",
    backgroundColor: tokens.colorNeutralBackground2, //'#f9f9f9',
    borderRadius: "8px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
  },
  headerRow: {
    ...headerRow,
    "@media (max-width: 768px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "10px",
    },
  },
  sectionTitle: {
    margin: 0,
    fontSize: "1.1rem",
    fontWeight: 700,
    color: tokens.colorNeutralForeground1,
    "@media (max-width: 768px)": {
      fontSize: "1rem",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "16px",
    marginTop: "5px",
    paddingTop: "5px",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  gridRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1.9fr",
    columnGap: "22px",
    rowGap: "14px",
    alignItems: "center",
    fontSize: "1.1rem",
    lineHeight: 1.5,
    color: tokens.colorNeutralForeground1,
    marginBottom: "14px",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr",
      rowGap: "10px",
      columnGap: "0",
      alignItems: "start",
    },
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1.9fr 1fr 1.9fr",
    columnGap: "22px",
    rowGap: "8px",
    alignItems: "center",
    fontSize: "1.1rem",
    lineHeight: 1.5,
    color: tokens.colorNeutralForeground1,
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr",
      rowGap: "10px",
      columnGap: "0",
      alignItems: "start",
    },
  },
  gridSubContainer: {
    display: "grid",
    gridTemplateColumns: "0.5fr 1.9fr 1.9fr",
    columnGap: "22px",
    rowGap: "8px",
    alignItems: "center",
    fontSize: "1.1rem",
    lineHeight: 1.5,
    borderTop: "1px solid #e3e8ee",
    marginTop: "18px",
    paddingTop: "10px",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr",
      rowGap: "10px",
      columnGap: "0",
      alignItems: "start",
    },
  },
  grid: {
    ...grid,
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr",
      rowGap: "10px",
      columnGap: "0",
      alignItems: "start",
    },
  },
  searchBoxHistory: {
    width: "400px !important",
    "@media (max-width: 768px)": {
      width: "100%",
    },
  },
  input: {
    width: "100%",
    minHeight: "35px",
    borderRadius: "6px",
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    boxSizing: "border-box",
  },
  label: {
    fontSize: "14px",
    fontWeight: 600,
    color: tokens.colorNeutralForeground1,
    whiteSpace: "nowrap",
    "@media (max-width: 768px)": {
      whiteSpace: "normal",
      fontSize: "13px",
    },
  },
  sidePanelLabel: {
    fontSize: "0.85rem",
    fontWeight: 600,
    color: tokens.colorNeutralForeground2,
    display: "flex",
    alignItems: "center",
    paddingBottom: "3px",
  },
  value: {
    fontSize: "14px",
    color: tokens.colorNeutralForeground2,
    minWidth: 0,
    "@media (max-width: 768px)": {
      fontSize: "13px",
      marginBottom: "4px",
    },
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "15px",
    paddingBottom: "8px",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr",
      gap: "12px",
      paddingBottom: "12px",
    },
  },
  field: {
    display: "flex",
    flexDirection: "column",
  },
} satisfies Record<string, GriffelStyle>;

export const useStyles = makeStyles(sharedStyles);

export const useGrunddatenStyles = makeStyles({
  ...sharedStyles,
  labelSingle: {
    ...sharedStyles.label,
    gridColumn: "1",
    "@media (max-width: 768px)": {
      ...sharedStyles.label["@media (max-width: 768px)"],
      gridColumn: "1 / -1",
    },
  },
  valueSingle: {
    ...sharedStyles.value,
    gridColumn: "2 / span 2",
    "@media (max-width: 768px)": {
      ...sharedStyles.value["@media (max-width: 768px)"],
      gridColumn: "1 / -1",
      width: "100%",
    },
  },
  valueSingleZusatz: {
    ...sharedStyles.value,
    gridColumn: "2 / span 3",
    "@media (max-width: 768px)": {
      ...sharedStyles.value["@media (max-width: 768px)"],
      gridColumn: "1 / -1",
      width: "100%",
    },
  },
  valueWeiter: {
    ...sharedStyles.value,
    gridColumn: "4",
    "@media (max-width: 768px)": {
      ...sharedStyles.value["@media (max-width: 768px)"],
      gridColumn: "1 / -1",
    },
  },
});

export const useQualifikationsprofilStyles = makeStyles({
  ...sharedStyles,
  rasterSelector: {
    display: "grid",
    gridTemplateColumns:
      "minmax(180px, 1fr) minmax(250px, 1.4fr) minmax(200px, 1.5fr) auto",
    alignItems: "center",
    gap: "20px",
    padding: "12px 16px",
    marginBottom: "16px",
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRadius: "6px",
    backgroundColor: tokens.colorNeutralBackground1,
    "@media (max-width: 1100px)": {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
    "@media (max-width: 768px)": {
      gridTemplateColumns: "minmax(0, 1fr)",
      gap: "12px",
    },
  },
  rasterHint: {
    fontSize: "12px",
    lineHeight: 1.2,
    color: tokens.colorNeutralForeground2,
    marginTop: "2px",
  },
  rasterSource: {
    justifyContent: "space-between",
  },
  rasterProject: {
    width: "100%",
    minWidth: 0,
  },
  rasterError: {
    color: tokens.colorPaletteRedForeground1,
    marginTop: 0,
    marginBottom: "12px",
  },
});

export const useProjektplanStyles = makeStyles({
  ...sharedStyles,
  valueSingle: {
    ...sharedStyles.value,
    gridColumn: "2 / span 2",
    "@media (max-width: 768px)": {
      ...sharedStyles.value["@media (max-width: 768px)"],
      gridColumn: "1 / -1",
      width: "100%",
    },
  },
  projectSummary: {
    gridColumn: "1 / -1",
    display: "grid",
    gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
    columnGap: "22px",
    rowGap: "8px",
    borderBottom: "1px solid #e3e8ee",
    marginBottom: "18px",
    paddingBottom: "10px",
    "@media (max-width: 1000px)": {
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    },
    "@media (max-width: 600px)": {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      columnGap: "12px",
    },
  },
  projectSummaryItem: {
    display: "grid",
    alignContent: "start",
    gap: "2px",
    minWidth: 0,
  },
  projectSummaryLabel: {
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: 1.3,
    color: tokens.colorNeutralForeground1,
  },
  projectSummaryValue: {
    fontSize: "13px",
    lineHeight: 1.4,
    color: tokens.colorNeutralForeground2,
    overflowWrap: "anywhere",
  },
  valueWeiter: {
    ...sharedStyles.value,
    gridColumn: "4",
    "@media (max-width: 768px)": {
      ...sharedStyles.value["@media (max-width: 768px)"],
      gridColumn: "1 / -1",
    },
  },
});

export const useDokumenteStyles = makeStyles({
  section: sharedStyles.section,
  // Document headers keep their horizontal layout on mobile.
  headerRow,
  sectionTitle: sharedStyles.sectionTitle,
  uploadRow: {
    paddingBottom: "12px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  grid: grid,
  hiddenFileInput: {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: 0,
  },
  fileUploadLabel: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 12px",
    borderRadius: "6px",
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: 1.2,
  },
  message: {
    fontSize: "14px",
    marginBottom: "12px",
  },
  iconCell: {
    width: "20px",
    minWidth: "20px",
    maxWidth: "20px",
    justifyContent: "center",
    paddingInline: 0,
    fontSize: "25px",
  },
  deleteCell: {
    width: "24px",
    minWidth: "24px",
    maxWidth: "24px",
    justifyContent: "center",
    paddingInline: 0,
  },
});
